import { useDispatch } from "react-redux";
import Logger from "../helpers/logger";
import ErrorTracker from "../helpers/errorTracker";
import { getConsent, hasConsent } from "../../storage/consent";
import { setConsent, setLoadedConsent } from "../slice/consent/consentSlice";

export const useLoadConsent = () => {
  const dispatch = useDispatch();

  const loadConsent = async () => {
    try {
      if (hasConsent()) {
        const consent = getConsent();
        if (consent) {
            dispatch(setConsent(consent));
        }
      }
    } catch (error) {
      Logger.for("loadConsent").error(error);
      ErrorTracker.trackException(error as Error);
    } finally {
      // Loaded even when storage throws (blocked in a third-party frame, for
      // the public plan): otherwise the app waits behind a spinner forever.
      dispatch(setLoadedConsent());
    }
  };
  return loadConsent;
};
